import React from 'react';
import { useLocalStore, useObserver } from 'mobx-react';
import { ScoreDetailService } from 'services';
import VolleyballMatchLineupTeamDataModel from './model';

const VolleyballMatchLineupStore = () => {
  const store = useLocalStore(() => ({
    lineup: {
      home: {
        id: null,
        name: null,
        imgPath: null,
        additionalTeamData: []
      },
      away: {
        id: null,
        name: null,
        imgPath: null,
        additionalTeamData: []
      }
    },
    loading: false,
    init: false,

    async getLineup(gameId) {
      store.loading = true;

      const result = await ScoreDetailService.getLineupBySportsType(
        'volleyball',
        gameId
      );

      if (!!result) {
        const deep = result;

        if (result.home.additionalTeamData.length > 0) {
          deep.home.additionalTeamData = result.home.additionalTeamData.map(
            (item) => new VolleyballMatchLineupTeamDataModel(item, 'home')
          );
        }
        if(result.away.additionalTeamData.length > 0) {
          deep.away.additionalTeamData = result.away.additionalTeamData.map(
            (item) => new VolleyballMatchLineupTeamDataModel(item, 'away')
          );
        }

        store.lineup = deep;
        store.loading = false;
        store.init = true;
      }
    }
  }));

  return {
    getLineup: store.getLineup,
    data: useObserver(() => {
      return {
        init: store.init,
        loading: store.loading,
        home: store.lineup.home,
        away: store.lineup.away,
      };
    })
  };
};

export default VolleyballMatchLineupStore;
